import { render, staticRenderFns } from "./zhuanyouxiazuoshang.vue?vue&type=template&id=7f0608ae&scoped=true&"
import script from "./zhuanyouxiazuoshang.vue?vue&type=script&lang=js&"
export * from "./zhuanyouxiazuoshang.vue?vue&type=script&lang=js&"
import style0 from "./zhuanyouxiazuoshang.vue?vue&type=style&index=0&id=7f0608ae&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f0608ae",
  null
  
)

export default component.exports